'use client';

import dayjs from 'dayjs';
import localizedFormat from 'dayjs/plugin/localizedFormat';

dayjs.extend(localizedFormat);

const LocalDate: React.FC<{
  date: Date;
  format: string;
}> = (props) => {
  const { date, format } = props;

  return (
    <>
      {dayjs(date).format(format)}
    </>
  );
};

export default LocalDate;
